import React from "react";

import svg from "../../assets/images/icons/branch.svg";

export const BranchIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Branch"}
    />
);
